export default {"src":"/_next/static/media/wavy-bottom.294472e3.svg","height":25,"width":1678,"blurWidth":0,"blurHeight":0};